import { createTheme } from "@mui/material/styles";

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#4f3edb", // Custom primary color
      contrastText: "#FFFFFF", // Text color
    },
    secondary: {
      main: "#DEDEDE", // Custom secondary color
      contrastText: "#000000",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // Remove uppercase text
          borderRadius: "8px", // Rounded corners
          // padding: "10px 20px",
          fontWeight: 600,
          fontFamily: "inter",
        },
        containedPrimary: {
          backgroundColor: "#5544DC",
          "&:hover": {
            backgroundColor: "#3624c1", // Darker shade on hover
          },
          "&.Mui-disabled": {
            backgroundColor: "#9d94ed", // Custom disabled background color
            color: "#FFFFFF", // Custom disabled text color
          },
        },
        containedSecondary: {
          backgroundColor: "#DEDEDE", // Gray background
          color: "#000000", // White text
          boxShadow: "none", // No shadow
          fontWeight: 600,
          fontFamily: "inter",
          "&:hover": {
            backgroundColor: "#bfbfbf", // Darker gray on hover
            boxShadow: "none", // Ensure no shadow on hover
          },
          "&.Mui-disabled": {
            backgroundColor: "#E0E0E0", // Light gray when disabled
            color: "#9E9E9E", // Text color when disabled
          },
        },
      },
    },
  },
});

export default customTheme;
